class StepGDPRController {
    /**
     * @param {Object} evaluationService
     * @param {$stateParams} $stateParams
     * @param {$timeout} $timeout
     * @param {$state} $state
     */
    constructor(evaluationService, $stateParams, $scope, userService, $state) {
        this.evaluationService = evaluationService;
        this.$scope = $scope;
        this.state = $state;
        this.evaluationId = $stateParams.id;
        this.stateParams = $stateParams;
        this.userService = userService;
        /** This link should be configurable
         *  For test env and dev - https://demoapp.gdpr.school/eaf-survey/
         *  For prod - https://app.gdpr.school/eaf-survey/
         */
        const rootUrl = 'https://app.gdpr.school/eaf-survey/';

        console.log(this.evaluationId, 'evaluationId');

        if (this.evaluationId) {
            evaluationService
                .getEvaluationData(this.evaluationId, true)
                .then((data) => {
                    const secret = data.secretId;
                    if (secret) {
                        this.gdprLinkUrl = rootUrl + secret;
                    }
                })
                .catch((err) => {
                    console.log(err.stateText);
                });
        }

        if (this.evaluationId) {
            evaluationService
                .getGdprSurvey(this.evaluationId)
                .then((data) => {
                    this.basicGdpr = { ...this.basicGdpr, ...data };
                })
                .catch((err) => {
                    console.log(err.stateText);
                });
        }

        this.findFlagSection = (assessment) => {
            if (assessment <= 2) {
                return 'Red';
            }
            if (assessment >= 3 && assessment <= 4) {
                return 'Amber';
            }
            if (assessment >= 5 && assessment <= 6) {
                return 'Yellow';
            }
            if (assessment >= 7 && assessment <= 10) {
                return 'Green';
            }
        };

        this.findFlagSectionColor = (assessment) => {
            if (assessment <= 2) {
                return 'color: red';
            }
            if (assessment >= 3 && assessment <= 4) {
                return 'color: darkorange';
            }
            if (assessment >= 5 && assessment <= 6) {
                return 'color: gold';
            }
            if (assessment >= 7 && assessment <= 10) {
                return 'color: green';
            }
        };
    }
}

StepGDPRController.$inject = [
    'EvaluationService',
    '$stateParams',
    'PedagogicalService',
    'UserService',
];

export default StepGDPRController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepGDPR/stepGDPRController.js